import { useLazyQuery } from '@apollo/client';
import { Identifiable } from '../../../lib/types';
import { GET_JOB } from './job.queries';
import { IJob } from './job.types';

export const useLazyGetJob = () => {
  const [query, rest] = useLazyQuery<{ getJob: IJob }, Identifiable>(GET_JOB, { fetchPolicy: 'no-cache' });

  return { ...rest, getJob: query };
};
